import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '../../components/Layout';
import { Tabs } from '../../components/Common';
import type { Tab } from '../../components/Common';
import ApplicationsNew from './ApplicationsNew';
import ApplicationsApproved from './ApplicationsApproved';
import ApplicationsInfoRequested from './ApplicationsInfoRequested';

const Applications: React.FC = () => {
  const [searchParams] = useSearchParams();
  const applicationIdFromUrl = searchParams.get('applicationId');
  
  const [activeTab, setActiveTab] = useState<'new' | 'approved' | 'info_requested'>('new');
  const [searchQuery, setSearchQuery] = useState('');
  
  // If applicationId is in URL, set it as search query and switch to appropriate tab
  useEffect(() => {
    if (applicationIdFromUrl) {
      setSearchQuery(applicationIdFromUrl);
      // Note: We'll let the child components handle finding the application
      // They'll check all tabs if needed
    }
  }, [applicationIdFromUrl]);

  const tabs: Tab[] = [
    { key: 'new', label: 'New' },
    { key: 'approved', label: 'Approved' },
    { key: 'info_requested', label: 'Info Requested' },
  ];

  return (
    <Box
      className="page-container"
      sx={{
        padding: {
          xs: '24px 16px',
          sm: '40px 40px',
          md: '40px 80px',
        },
        gap: '24px',
      width: '100%', 
        height: '100%',
        boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Page Header */}
      <PageHeader
        title="Applications"
        showSearch
        searchPlaceholder="Search applications"
        searchValue={searchQuery}
        onSearchChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Tabs and Table Section */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', gap: '32px', width: '100%', flex: 1, overflow: 'hidden' }}>
        {/* Tabs */}
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={(tabKey) => setActiveTab(tabKey as typeof activeTab)}
        />

        {/* Tab Content */}
        {activeTab === 'new' && <ApplicationsNew searchQuery={searchQuery} applicationId={applicationIdFromUrl || undefined} />}
        {activeTab === 'approved' && <ApplicationsApproved searchQuery={searchQuery} applicationId={applicationIdFromUrl || undefined} />}
        {activeTab === 'info_requested' && <ApplicationsInfoRequested applicationId={applicationIdFromUrl || undefined} />}
      </Box>
    </Box>
  );
};

export default Applications;
